import { Theme } from "@emotion/react";

export const theme: Theme = {
  color: {
    primary: "rgb(89, 50, 134)",
    secondary: "rgb(255, 235, 122)",
    good: "#003d88",
    evil: "#880000",
  },
};
